export default function FujiMoneyIcon() {
  return <img height='48px' width='48px' src='/fuji-money.png' />
}
